// extracted by mini-css-extract-plugin
export var wordContainer = "_qt-0";